import { CSSProperties } from 'react'

import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import { ChevronRight } from '@mxenabled/mx-icons'

import { InstitutionLogo } from '@mxenabled/mxui'

interface PopularTopicsRowProps {
  name: string
  guid?: string
  subtitle?: string
  onClick: () => void
  sx?: CSSProperties
}

export const PopularTopicsRow: React.FC<PopularTopicsRowProps> = ({
  name,
  onClick,
  subtitle,
  guid,
  sx,
}) => (
  <ListItem disableGutters={true} disablePadding={true}>
    <ListItemButton aria-label={name} onClick={onClick}>
      {guid && (
        <ListItemAvatar>
          <InstitutionLogo alt={name} institutionGuid={guid || ''} size={32} />
        </ListItemAvatar>
      )}
      <ListItemText
        primary={name}
        secondary={subtitle}
        slotProps={{
          primary: { style: { ...sx }, variant: 'body1' },
          secondary: { variant: 'caption' },
        }}
      />
      <ListItemIcon>
        <ChevronRight />
      </ListItemIcon>
    </ListItemButton>
  </ListItem>
)
